(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5159],{

/***/ 1646:
/***/ (function(module) {

!function(t,s){ true?module.exports=s():0}(this,(function(){"use strict";var t,s,n=1e3,i=6e4,e=36e5,r=864e5,o=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,u=31536e6,h=2592e6,a=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/,d={years:u,months:h,days:r,hours:e,minutes:i,seconds:n,milliseconds:1,weeks:6048e5},c=function(t){return t instanceof p},f=function(t,s,n){return new p(t,n,s.$l)},m=function(t){return s.p(t)+"s"},l=function(t){return t<0},$=function(t){return l(t)?Math.ceil(t):Math.floor(t)},y=function(t){return Math.abs(t)},g=function(t,s){return t?l(t)?{negative:!0,format:""+y(t)+s}:{negative:!1,format:""+t+s}:{negative:!1,format:""}},p=function(){function l(t,s,n){var i=this;if(this.$d={},this.$l=n,void 0===t&&(this.$ms=0,this.parseFromMilliseconds()),s)return f(t*d[m(s)],this);if("number"==typeof t)return this.$ms=t,this.parseFromMilliseconds(),this;if("object"==typeof t)return Object.keys(t).forEach((function(s){i.$d[m(s)]=t[s]})),this.calMilliseconds(),this;if("string"==typeof t){var e=t.match(a);if(e){var r=e.slice(2).map((function(t){return Number(t)}));return this.$d.years=r[0],this.$d.months=r[1],this.$d.weeks=r[2],this.$d.days=r[3],this.$d.hours=r[4],this.$d.minutes=r[5],this.$d.seconds=r[6],this.calMilliseconds(),this}}return this}var y=l.prototype;return y.calMilliseconds=function(){var t=this;this.$ms=Object.keys(this.$d).reduce((function(s,n){return s+(t.$d[n]||0)*d[n]}),0)},y.parseFromMilliseconds=function(){var t=this.$ms;this.$d.years=$(t/u),t%=u,this.$d.months=$(t/h),t%=h,this.$d.days=$(t/r),t%=r,this.$d.hours=$(t/e),t%=e,this.$d.minutes=$(t/i),t%=i,this.$d.seconds=$(t/n),t%=n,this.$d.milliseconds=t},y.toISOString=function(){var t=g(this.$d.years,"Y"),s=g(this.$d.months,"M"),n=+this.$d.days||0;this.$d.weeks&&(n+=7*this.$d.weeks);var i=g(n,"D"),e=g(this.$d.hours,"H"),r=g(this.$d.minutes,"M"),o=this.$d.seconds||0;this.$d.milliseconds&&(o+=this.$d.milliseconds/1e3);var u=g(o,"S"),h=t.negative||s.negative||i.negative||e.negative||r.negative||u.negative,a=e.format||r.format||u.format?"T":"",d=(h?"-":"")+"P"+t.format+s.format+i.format+a+e.format+r.format+u.format;return"P"===d||"-P"===d?"P0D":d},y.toJSON=function(){return this.toISOString()},y.format=function(t){var n=t||"YYYY-MM-DDTHH:mm:ss",i={Y:this.$d.years,YY:s.s(this.$d.years,2,"0"),YYYY:s.s(this.$d.years,4,"0"),M:this.$d.months,MM:s.s(this.$d.months,2,"0"),D:this.$d.days,DD:s.s(this.$d.days,2,"0"),H:this.$d.hours,HH:s.s(this.$d.hours,2,"0"),m:this.$d.minutes,mm:s.s(this.$d.minutes,2,"0"),s:this.$d.seconds,ss:s.s(this.$d.seconds,2,"0"),SSS:s.s(this.$d.milliseconds,3,"0")};return n.replace(o,(function(t,s){return s||String(i[t])}))},y.as=function(t){return this.$ms/d[m(t)]},y.get=function(t){var s=this.$ms,n=m(t);return"milliseconds"===n?s%=1e3:s="weeks"===n?$(s/d[n]):this.$d[n],0===s?0:s},y.add=function(t,s,n){var i;return i=s?t*d[m(s)]:c(t)?t.$ms:f(t,this).$ms,f(this.$ms+i*(n?-1:1),this)},y.subtract=function(t,s){return this.add(t,s,!0)},y.locale=function(t){var s=this.clone();return s.$l=t,s},y.clone=function(){return f(this.$ms,this)},y.humanize=function(s){return t().add(this.$ms,"ms").locale(this.$l).fromNow(!s)},y.milliseconds=function(){return this.get("milliseconds")},y.asMilliseconds=function(){return this.as("milliseconds")},y.seconds=function(){return this.get("seconds")},y.asSeconds=function(){return this.as("seconds")},y.minutes=function(){return this.get("minutes")},y.asMinutes=function(){return this.as("minutes")},y.hours=function(){return this.get("hours")},y.asHours=function(){return this.as("hours")},y.days=function(){return this.get("days")},y.asDays=function(){return this.as("days")},y.weeks=function(){return this.get("weeks")},y.asWeeks=function(){return this.as("weeks")},y.months=function(){return this.get("months")},y.asMonths=function(){return this.as("months")},y.years=function(){return this.get("years")},y.asYears=function(){return this.as("years")},l}();return function(n,i,e){t=e,s=e().$utils(),e.duration=function(t,s){var n=e.locale();return f(t,{$l:n},s)},e.isDuration=c;var r=i.prototype.add,o=i.prototype.subtract;i.prototype.add=function(t,s){return c(t)&&(t=t.asMilliseconds()),r.bind(this)(t,s)},i.prototype.subtract=function(t,s){return c(t)&&(t=t.asMilliseconds()),o.bind(this)(t,s)}}}));

/***/ }),

/***/ 66607:
/***/ (function(module) {

!function(e,i){ true?module.exports=i():0}(this,(function(){"use strict";return function(e,i,t){i.prototype.isBetween=function(e,i,s,f){var n=t(e),o=t(i),r="("===(f=f||"()")[0],u=")"===f[1];return(r?this.isAfter(n,s):!this.isBefore(n,s))&&(u?this.isBefore(o,s):!this.isAfter(o,s))||(r?this.isBefore(n,s):!this.isAfter(n,s))&&(u?this.isAfter(o,s):!this.isBefore(o,s))}}}));

/***/ }),

/***/ 41227:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[eventId]",
      function () {
        return __webpack_require__(81528);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34065);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _CourseHero_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53713);
/* harmony import */ var _CourseHero_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_CourseHero_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var CourseHero = function(param) {
    var title = param.title, subTitle = param.subTitle, heroImg = param.heroImg, textColor = param.textColor;
    var isLaptop = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .a)("(min-width: 768px) and (max-width: 1023px)");
    var isTablet = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .a)("(max-width: 767px)");
    var sm = heroImg.sm, md = heroImg.md, lg = heroImg.lg;
    var getBgImg = function() {
        if (isTablet) {
            return sm;
        }
        if (isLaptop) {
            return md;
        }
        return lg;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "mx-auto max-w-screen-2xl ".concat((_CourseHero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().HeroWrap)),
        style: {
            backgroundImage: "url(".concat(getBgImg(), ")")
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mx-4 hidden h-full max-w-7xl flex-col justify-center md:flex xl:mx-auto xl:px-6",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "mb-4 font-bold ".concat((_CourseHero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().HeroTitle), " break-words"),
                    style: !lodash__WEBPACK_IMPORTED_MODULE_1___default().isNull(textColor) ? {
                        color: "".concat(textColor)
                    } : {},
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "".concat((_CourseHero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().HeroSubTitle)),
                    style: !lodash__WEBPACK_IMPORTED_MODULE_1___default().isNull(textColor) ? {
                        color: "".concat(textColor)
                    } : {},
                    children: subTitle
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CourseHero);


/***/ }),

/***/ 81528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _eventId_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/DetailRender/HTMLRender.tsx
var HTMLRender = __webpack_require__(97205);
// EXTERNAL MODULE: ./designs/CourseHero/index.tsx
var CourseHero = __webpack_require__(40840);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-media-query/use-media-query.js
var use_media_query = __webpack_require__(34065);
// EXTERNAL MODULE: ./components/CourseInfo/ActionButton.tsx
var ActionButton = __webpack_require__(95112);
// EXTERNAL MODULE: ./components/CourseInfo/KlassInfoHeader.tsx + 2 modules
var KlassInfoHeader = __webpack_require__(94501);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isBetween.js
var isBetween = __webpack_require__(66607);
var isBetween_default = /*#__PURE__*/__webpack_require__.n(isBetween);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./shared/layout/WithHeader/index.tsx + 1 modules
var WithHeader = __webpack_require__(89123);
// EXTERNAL MODULE: ./pages/event/[eventId]/eventDetail.module.scss
var eventDetail_module = __webpack_require__(21211);
var eventDetail_module_default = /*#__PURE__*/__webpack_require__.n(eventDetail_module);
;// CONCATENATED MODULE: ./features/event/components/EOEvent/index.tsx










dayjs_min_default().extend((isBetween_default()));
var EOEvent = function(param) {
    var course = param.course;
    var ref;
    var applyStartedAt = course.applyStartedAt, applyEndedAt = course.applyEndedAt, flags = course.flags;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,use_media_query/* useMediaQuery */.a)("max-width:1023px");
    var url = (ref = flags === null || flags === void 0 ? void 0 : flags.find(function(item) {
        return item.startsWith("url:");
    })) === null || ref === void 0 ? void 0 : ref.replace("url:", "");
    var isApplyPeriod = dayjs_min_default()().isBetween(dayjs_min_default()(applyStartedAt, "YYYY-MM-DDTHH:mm:ss.000ZZ").format(), dayjs_min_default()(applyEndedAt, "YYYY-MM-DDTHH:mm:ss.000ZZ").format());
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WithHeader/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
            style: {
                minWidth: 360,
                marginBottom: 220
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-5 max-w-7xl lg:mt-6 lg:px-4 xl:mx-auto xl:px-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:flex lg:flex-row-reverse lg:items-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                            className: "".concat((eventDetail_module_default()).rightPanel, " mb-6 h-auto lg:sticky lg:right-0 lg:mb-0 lg:shrink-0"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-4 lg:rounded-lg lg:border lg:border-gray-300 lg:p-6 lg:pt-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(KlassInfoHeader/* default */.Z, {
                                        isMobile: isMobile,
                                        klassId: course.id,
                                        title: course.title,
                                        panelText: course.panelText,
                                        shareUrl: course.shareUrl,
                                        imgUrl: course.imageM
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "mb-4 w-full border-gray-300 lg:hidden"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "fixed bottom-0 left-0 right-0 z-20 whitespace-nowrap border border-t bg-white px-4 pb-4 lg:static lg:border-none lg:px-0 lg:pb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* default */.Z, {
                                            course: course,
                                            klassId: course.id,
                                            disabled: !isApplyPeriod,
                                            handler: function() {
                                                return router.push(url);
                                            },
                                            name: "선착순 | 이벤트 참여하기"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:mr-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                    className: "h-3 w-full border-none bg-gray-100 lg:hidden"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "px-4 pb-20 pt-4 lg:p-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLRender/* default */.Z, {
                                        html: course.description
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var components_EOEvent = (EOEvent);

// EXTERNAL MODULE: ./components/CourseInfo/KlassInfoSection.tsx
var KlassInfoSection = __webpack_require__(91251);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./shared/contexts/Auth.tsx
var Auth = __webpack_require__(96759);
// EXTERNAL MODULE: ./shared/hooks/useCourseStatus.tsx
var useCourseStatus = __webpack_require__(55799);
// EXTERNAL MODULE: ./shared/hooks/useProgressNow.tsx
var useProgressNow = __webpack_require__(96525);
;// CONCATENATED MODULE: ./features/event/components/EventInfo/index.tsx












var EventInfo = function(param) {
    var course = param.course, curriculum = param.curriculum;
    var courseStatus = (0,useCourseStatus/* useCourseStatus */.$)(course.id).courseStatus;
    var isSigned = (0,Auth/* useAuth */.a)().isSigned;
    var ref = (0,useProgressNow/* useProgressNow */.t)(course.id, isSigned), resourceId = ref.id;
    var isMobile = (0,use_media_query/* useMediaQuery */.a)("max-width:1023px");
    var isEndedEvent = dayjs_min_default()().isAfter(course.endedAt);
    var router = (0,next_router.useRouter)();
    var applyStatusHandler = function() {
        // 이벤트 기간 = 교육기간이 오늘 이후면 -> 지난 이벤트
        // 교육 기간이 오늘 이전이면 -> 다가오는 이벤트
        return isEndedEvent ? "closed" : "apply";
    };
    var buttonLabelHandler = function() {
        if (courseStatus === "loading") return "Loading";
        if (!isEndedEvent && courseStatus === "enrollment") {
            return "결제하기";
        }
        if (!isEndedEvent && courseStatus === "play") {
            return "학습하기";
        }
        return "신청 종료";
    };
    var goToOrder = (0,react.useCallback)(function(courseId) {
        return router.push("/courses/technology/".concat(courseId, "/order")).then(function() {
            return window.scrollTo(0, 0);
        });
    }, [
        router
    ]);
    var goToPlayer = (0,react.useCallback)(function(courseId) {
        if (isSigned && resourceId && !(0,lodash.isEmpty)(curriculum) && courseStatus === "play") {
            var ref;
            var chapterId = (ref = curriculum.find(function(chapter) {
                return chapter.resources.find(function(resource) {
                    return resource.id === resourceId;
                });
            })) === null || ref === void 0 ? void 0 : ref.id;
            return router.push("/courses/technology/".concat(courseId, "/").concat(chapterId, "/").concat(resourceId));
        }
    }, [
        courseStatus,
        curriculum,
        isSigned,
        resourceId,
        router
    ]);
    var priceToString = function(price) {
        return price === null || price === void 0 ? void 0 : price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-4 lg:rounded-lg lg:border lg:border-gray-300 lg:p-6 lg:pt-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(KlassInfoHeader/* default */.Z, {
                isMobile: isMobile,
                klassId: course.id,
                title: course.title,
                panelText: course.panelText,
                shareUrl: course.shareUrl,
                imgUrl: course.imageM
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "mb-4 w-full border-gray-300 lg:hidden"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(KlassInfoSection/* default */.Z, {
                        course: course,
                        isKDT: false,
                        isSimplifyKDT: false,
                        applyStatus: applyStatusHandler()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "my-4 border-gray-300"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col space-y-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex text-sm text-gray-500"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-baseline space-x-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-baseline space-x-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-xl font-semibold leading-tight",
                                        children: [
                                            priceToString(course.price),
                                            "원"
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed bottom-0 left-0 right-0 z-20 border border-t bg-white px-4 pb-4 lg:static lg:border-none lg:px-0 lg:pb-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* default */.Z, {
                            course: course,
                            klassId: course.id,
                            disabled: courseStatus === "loading" || isEndedEvent,
                            handler: function() {
                                return courseStatus === "play" ? goToPlayer(course.id) : goToOrder(course.id);
                            },
                            name: buttonLabelHandler()
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_EventInfo = (EventInfo);

// EXTERNAL MODULE: ./shared/hooks/useSections.tsx
var useSections = __webpack_require__(78427);
;// CONCATENATED MODULE: ./pages/event/[eventId]/index.tsx










var EventDetail = function() {
    var router = (0,next_router.useRouter)();
    var courseId = (0,react.useMemo)(function() {
        return router.query.eventId;
    }, [
        router
    ]);
    var ref = (0,useSections/* useSections */._)(courseId), course = ref.course, curriculum = ref.curriculum;
    (0,react.useEffect)(function() {
        if (courseId === "k-tech-college") {
            void router.push("https://likelion2.typeform.com/to/i3J0NqRV");
        }
    }, [
        courseId,
        router
    ]);
    if (courseId === "eo-event") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EOEvent, {
            course: course
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WithHeader/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            style: {
                minWidth: 360,
                marginBottom: 220
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseHero/* default */.Z, {
                    title: course.title,
                    subTitle: course.subtitle,
                    heroImg: {
                        sm: course.bannerBgImgS,
                        md: course.bannerBgImgM,
                        lg: course.bannerBgImg
                    },
                    textColor: course.bannerTextColor
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-5 max-w-7xl lg:mt-6 lg:px-4 xl:mx-auto xl:px-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:flex lg:flex-row-reverse lg:items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                                className: "".concat((eventDetail_module_default()).rightPanel, " mb-6 h-auto lg:sticky lg:right-0 lg:mb-0 lg:shrink-0"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EventInfo, {
                                    course: course,
                                    curriculum: curriculum
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:mr-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "h-3 w-full border-none bg-gray-100 lg:hidden"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-4 pb-20 pt-4 lg:p-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLRender/* default */.Z, {
                                            html: course.description
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var _eventId_ = (EventDetail);


/***/ }),

/***/ 55799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useCourseStatus; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82332);
/* harmony import */ var stores_permission__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39795);



var useCourseStatus = function(courseId) {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var courseStatus = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.permission;
    }).courseStatus;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        dispatch((0,stores_permission__WEBPACK_IMPORTED_MODULE_2__/* .getCourseStatusThunk */ .rQ)(courseId));
    }, [
        courseId,
        dispatch
    ]);
    return {
        courseStatus: courseStatus
    };
};


/***/ }),

/***/ 96525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useProgressNow; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82332);
/* harmony import */ var _stores_courses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70957);




var useProgressNow = function(courseId, isSigned) {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var progressNow = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.courses.progressNow;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isSigned && !lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(courseId)) {
            dispatch((0,_stores_courses__WEBPACK_IMPORTED_MODULE_3__/* .fetchProgressNowThunk */ ._4)(courseId));
        }
    }, [
        isSigned,
        courseId,
        dispatch
    ]);
    return progressNow;
};


/***/ }),

/***/ 78427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useSections; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82332);
/* harmony import */ var _stores_courses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70957);




var useSections = function(courseId) {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.courses;
    }), isLoading = ref.isLoading, sections = ref.sections;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(courseId) && (lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(sections) || !lodash__WEBPACK_IMPORTED_MODULE_0___default().isEqual(sections === null || sections === void 0 ? void 0 : sections.id, courseId))) {
            dispatch((0,_stores_courses__WEBPACK_IMPORTED_MODULE_3__/* .fetchCourseSectionsThunk */ .iB)(courseId));
        }
    }, [
        courseId,
        sections,
        dispatch
    ]);
    var course = lodash__WEBPACK_IMPORTED_MODULE_0___default().omit(sections, "chapters");
    var ref1;
    var curriculum = (ref1 = lodash__WEBPACK_IMPORTED_MODULE_0___default().get(sections, "chapters")) !== null && ref1 !== void 0 ? ref1 : [];
    return {
        isLoading: isLoading,
        course: course,
        curriculum: curriculum
    };
};


/***/ }),

/***/ 53713:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HeroWrap":"CourseHero_HeroWrap__7r73W","HeroTitle":"CourseHero_HeroTitle__8_Yjh","HeroSubTitle":"CourseHero_HeroSubTitle__K6Tju"};

/***/ }),

/***/ 21211:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"rightPanel":"eventDetail_rightPanel__NApJB"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6408,4653,3607,346,4872,3881,5202,1623,9774,2888,179], function() { return __webpack_exec__(41227); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);